// extracted by css-extract-rspack-plugin
export default {"ErrorFlash":"ChecksGroup-module__ErrorFlash__a7Ow4lW","ErrorOcticon":"ChecksGroup-module__ErrorOcticon__SHyIVGT"};